import { QRCodeSVG } from '@rc-component/qrcode'
import { Modal } from 'component/Modal'
import { Gap } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { buyModal } from 'page/catalog/store/BuyModalStore'
import { ui } from 'store/home/ui/HomeUiStore'
import { buildBuyLink } from 'type/Item'

export const BuyModal = observer(() => {
  const { show_name } = buyModal.it
  const { product_name, links } = buyModal.it.item
  const link = buildBuyLink(links)
  const { width, height } = ui.window
  const size = Math.min(width - 64, height - 64, 320)

  const onClose = useLatestCallback(async () => {
    buyModal.close()
  })

  return (
    <Modal open={true} width={360} onCancel={onClose}>
      <Vertical pad={16} center>
        <Typo size={14} center semi upper>
          {show_name ? product_name : i18n('Item')}
        </Typo>
        <Gap height={16} />
        <QRCodeSVG value={link} size={size} />
        <Gap height={12} />
        <Typo size={12} center medium upper pre>
          {i18n('demo.ScanQrCodeAndOpenShopSite')}
        </Typo>
      </Vertical>
    </Modal>
  )
})
